import moment from "moment";

export function roundToNearestHalfHour(timeStr) {
  const time = moment(timeStr, "HH:mm");
  const minutes = time.minutes();

  if (minutes < 30) {
    time.minutes(0);
  } else {
    time.minutes(30);
  }

  time.seconds(0);

  return time.format("HH:mm");
}
